import React from 'react'
import { Switch, Route } from 'react-router-dom'

import { WIDGET_EMBEDDABLE_ITEMS_PATH } from 'constants/routes/widget.constants'
import EmbeddableItem from './embeddable-items/EmbeddableItem'

const Routes = () => (
  <Switch>
    <Route exact path={WIDGET_EMBEDDABLE_ITEMS_PATH} component={EmbeddableItem} />
  </Switch>
)

export default Routes
